import { render } from "./ABtn.vue?vue&type=template&id=fdf0f884"
import script from "./ABtn.vue?vue&type=script&lang=js"
export * from "./ABtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__